import * as React from 'react';
import { GradientModal } from '@/components/ui/GradientModal';
import { Button } from '@/components/ui/Button';
import { connectedAccountsService } from '@/services/connectedAccountsService';

interface StripeGateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
}

export const StripeGateModal: React.FC<StripeGateModalProps> = ({ isOpen, onClose, onProceed }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleGoToStripe = async () => {
    setIsLoading(true);
    try {
      const response = await connectedAccountsService.create();
      window.location.href = response.onboarding_url;
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <GradientModal isOpen={isOpen} onClose={onClose} variant='purple'>
      <h2 className='mb-4 font-sans text-24 font-bold text-brand-800'>
        No Earnings Without Stripe
      </h2>
      <p className='mb-8 font-sans text-16 leading-24 text-modal-body'>
        You will not receive money until Stripe Connect is set up. You can do this later from your
        account settings.
      </p>

      <div className='flex items-center justify-between'>
        <Button
          onClick={() => {
            onClose();
            onProceed();
          }}
          variant='sidebar-default'
          className='h-[44px] rounded-30 px-10 font-sans text-16 font-semibold text-brand-800'
        >
          OK
        </Button>

        <Button
          onClick={handleGoToStripe}
          variant='purple-dark'
          disabled={isLoading}
          className='h-[44px] rounded-30 px-10 font-sans text-16 font-semibold'
        >
          {isLoading ? 'Connecting...' : 'Go to Stripe'}
        </Button>
      </div>
    </GradientModal>
  );
};
